import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=6264077e&scoped=true&lang=pug&"
import script from "./SelectBox.vue?vue&type=script&lang=coffee&"
export * from "./SelectBox.vue?vue&type=script&lang=coffee&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=6264077e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264077e",
  null
  
)

export default component.exports